import * as libraryEvents from "../services/realTimeNotification/events/library/libraryEvents";

const getSurveyAsyncOperations = () => [
  libraryEvents.SurveyUpdateSuccess,
  libraryEvents.SurveyQuestionsUpdateSuccess,
  libraryEvents.SurveyPublishSuccess,
  libraryEvents.SurveyEditSuccess,
  libraryEvents.SurveyDiscardSuccess,
];

const getEmbeddedVideOperations = () => [
  libraryEvents.EmbeddedVideoEditSuccess,
  libraryEvents.LockEmbeddedVideoSuccess,
  libraryEvents.EmbeddedVideoPublishSuccess,
  libraryEvents.EmbeddedVideoUpdateCommandCompleted,
  libraryEvents.EmbeddedVideoDiscardSuccess,
];

const getAssessmentAsyncOperations = () => [
  libraryEvents.AssessmentInfoEditSuccess,
  libraryEvents.AssessmentQuestionsEditSuccess,
  libraryEvents.AssessmentPublishSuccess,
  libraryEvents.AssessmentLockSuccess,
  libraryEvents.AssessmentDiscardSuccess,
];

const getEmailAsyncOperations = () => [
  libraryEvents.EmailEditSuccess,
  libraryEvents.EmailContentEditSuccess,
  libraryEvents.EmailPublishSuccess,
  libraryEvents.EmailEditModeSuccess,
  libraryEvents.EmailRevertSuccess,
];

const getEventAsyncOperations = () => [
  libraryEvents.EventInfoEditSuccess,
  libraryEvents.EventEditSessionsSuccess,
  libraryEvents.EventPublishSuccess,
  libraryEvents.ExternalEventEditModeSuccess,
  libraryEvents.EventDiscardedSuccess,
];

const getThreatDefenceCampaignAsyncOperations = () => [
  libraryEvents.CampaignEditV2Success,
  libraryEvents.CampaignPublishV2Success,
  libraryEvents.CampaignEmailTemplateEditSuccess,
  libraryEvents.CampaignFeedbackPageEditSuccess,
];

const getPackAsyncOperations = () => [
  libraryEvents.PackUpdateSuccess,
  libraryEvents.PackContentEditSuccess,
  libraryEvents.PackPublishSuccess,
  libraryEvents.PackLockSuccess,
  libraryEvents.PackDiscardSuccess,
  libraryEvents.EditAccountPackVisibilitySuccess,
  libraryEvents.EditAccountTypePackVisibilitySuccess,
  libraryEvents.EditPackIsPrivateSuccess,
];

const getVideoAsyncOperations = () => [
  libraryEvents.VideoAssetEditSuccess,
  libraryEvents.VideoAssetPublishSuccess,
  libraryEvents.LockVideoAssetSuccess,
  libraryEvents.VideoAssetsDiscardSuccess,
];

const getFlowsAsyncOperations = () => [
  libraryEvents.FlowEditSuccess,
  libraryEvents.FlowEditDefinitionSuccess,
  libraryEvents.FlowPublishSuccess,
  libraryEvents.FlowDiscardSuccess,
  libraryEvents.FlowLockSuccess,
  libraryEvents.FlowEditGoalsSuccess,
];

const getExternalLinkAsyncOperations = () => [
  libraryEvents.LinkEditSuccess,
  libraryEvents.LinkPublishSuccess,
  libraryEvents.LinkLockSuccess,
  libraryEvents.LinkDiscardSuccess,
];

const getAsyncOperations = () => [
  ...getSurveyAsyncOperations(),
  ...getEmbeddedVideOperations(),
  ...getAssessmentAsyncOperations(),
  ...getEmailAsyncOperations(),
  ...getEventAsyncOperations(),
  ...getThreatDefenceCampaignAsyncOperations(),
  ...getPackAsyncOperations(),
  ...getVideoAsyncOperations(),
  ...getFlowsAsyncOperations(),
  ...getExternalLinkAsyncOperations(),
];

export default getAsyncOperations;
